<script setup>

const colorMode = useColorMode()

const play = ref(false)
const audio = ref(null)
const strokeDashArrayValue = ref(72.2566310326)
const currentTime = ref(0)
const timeInterval = ref(null)

const props = defineProps({
	track: {
    type: Object,
  }
})

onMounted(() => {
  audio.value.addEventListener('ended', onAudioEnded)

	timeInterval.value = setInterval(function () {
		currentTime.value = audio.value.currentTime
	}, 30);
})

onUnmounted(() => {
	clearInterval(timeInterval.value)
})

const onAudioEnded = () => {
	play.value = false
}

const getProgress = () => {
	const percentDone = (currentTime.value / 30) * 100
	const percentDashArray = (percentDone / 100) * strokeDashArrayValue.value
	return strokeDashArrayValue.value - percentDashArray
}

const convertStoMs = (seconds) => {
	return `${Math.floor(seconds / 60)} : ${('0' + Math.floor(seconds % 60)).slice(-2)}`
}

watch(play, () => {
  if (play.value) {
		audio.value.play()
	} else {
		audio.value.pause()
	}
})


</script>

<template>
	<div class="w-full border border-[#999] cursor-pointer" @click="play = !play">
		<div class="p-4">
			<div class="flex items-center gap-5">
				<div class="flex w-full">
					<svg v-if="!play" class="mr-5"  xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" style="transform:rotate(-90deg)">
						<circle cx="12.5" cy="12.5" r="11.5" fill="transparent" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-dasharray="72.2566310326px" stroke-dashoffset="0" />
						<circle cx="12.5" cy="12.5" r="11.5" fill="transparent" stroke-linecap="butt" :stroke="colorMode.preference === 'dark' ? '#E4032E' : '#E4032E'" stroke-width="3" stroke-dasharray="72.2566310326px" :stroke-dashoffset="`${getProgress()}px`"/>
						<path style="transform:rotate(90deg) translate(0px, -25px)" d="M17 12.5L10 8V17L17 12.5Z" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="0.75" stroke-linecap="square" stroke-linejoin="bevel"/>
					</svg>
					<svg class="mr-5" v-else xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" style="transform:rotate(-90deg)">
						<circle cx="12.5" cy="12.5" r="11.5" fill="transparent" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-dasharray="72.2566310326px" stroke-dashoffset="0" />
						<circle cx="12.5" cy="12.5" r="11.5" fill="transparent" stroke-linecap="butt" :stroke="colorMode.preference === 'dark' ? '#E4032E' : '#E4032E'" stroke-width="3" stroke-dasharray="72.2566310326px" :stroke-dashoffset="`${getProgress()}px`"/>
						<path style="transform:rotate(90deg) translate(0px, -25px)" d="M14 17H15V8H14V17Z" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/>
						<path style="transform:rotate(90deg) translate(0px, -25px)" d="M10 17H11V8H10V17Z" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/>
					</svg>
					<p class="text-sm xl:text-lg">{{ track.name }}</p>
				</div>
				<p v-if="track.duration" class="text-sm xl:text-lg opacity-30 whitespace-nowrap">{{ convertStoMs(track.duration) }}</p>
			</div>
		</div>
		<audio class="opacity-0 h-0 pointer-events-none" ref="audio" v-if="track">
			<source :src="track.sample.stream">
		</audio>
	</div>
	
</template>